var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 144 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -16,
    y: -16,
    width: 176,
    height: 72
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(8px)",
      clipPath: "url(#bgblur_0_0_4_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 131",
    "data-figma-bg-blur-radius": 16
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 40,
    rx: 20,
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 143,
    height: 39,
    rx: 19.5,
    stroke: "var(--stroke-0, black)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8618 20.6359C42.8719 19.8694 43.0796 19.1177 43.4655 18.451C43.8515 17.7842 44.4032 17.224 45.0694 16.8225C44.6462 16.23 44.0879 15.7423 43.4389 15.3983C42.7899 15.0543 42.068 14.8634 41.3305 14.8408C39.7575 14.6789 38.2324 15.7637 37.4308 15.7637C36.6137 15.7637 35.3795 14.8569 34.0504 14.8837C33.1908 14.9109 32.353 15.156 31.6187 15.5951C30.8843 16.0342 30.2785 16.6522 29.8603 17.3891C28.0486 20.4644 29.4 24.9841 31.1355 27.47C32.0038 28.6873 33.0185 30.047 34.3464 29.9988C35.6458 29.9459 36.131 29.1864 37.6995 29.1864C39.2534 29.1864 39.7087 29.9988 41.0635 29.9681C42.4577 29.9459 43.3362 28.7454 44.1741 27.5166C44.7979 26.6493 45.278 25.6907 45.5965 24.6764C44.7864 24.3404 44.0952 23.7782 43.6089 23.0597C43.1226 22.3412 42.8627 21.4982 42.8618 20.6359Z",
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3029 13.2059C41.0631 12.3112 41.4376 11.1611 41.3469 10C40.1855 10.1196 39.1126 10.6638 38.3422 11.5243C37.9654 11.9446 37.6769 12.4336 37.4931 12.9633C37.3092 13.4931 37.2337 14.0531 37.2707 14.6115C37.8517 14.6174 38.4264 14.4939 38.9516 14.2504C39.4768 14.007 39.9388 13.6498 40.3029 13.2059Z",
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7253 25H54.0406L57.4685 15.0024H59.321L62.7416 25H60.9912L60.1087 22.2314H56.6151L55.7253 25ZM58.402 16.731H58.3364L56.9871 20.957H59.7367L58.402 16.731Z",
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3913 25.1099C66.3921 25.1099 65.6336 24.6338 65.2251 23.9233H65.1668V27.5708H63.5477V17.2583H65.123V18.3936H65.1814C65.6044 17.6538 66.3921 17.1558 67.4277 17.1558C69.1563 17.1558 70.3888 18.4668 70.3888 20.7812V21.4697C70.3888 23.7695 69.1709 25.1099 67.3913 25.1099ZM67.0193 23.7695C68.0477 23.7695 68.7478 22.9419 68.7478 21.3818V20.8398C68.7478 19.3384 68.0914 18.4814 66.9901 18.4814C65.8597 18.4814 65.1522 19.4043 65.1522 20.8325V21.3818C65.1522 22.8467 65.867 23.7695 67.0193 23.7695Z",
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.622 25.1099C74.6228 25.1099 73.8643 24.6338 73.4559 23.9233H73.3975V27.5708H71.7784V17.2583H73.3538V18.3936H73.4121C73.8351 17.6538 74.6228 17.1558 75.6585 17.1558C77.387 17.1558 78.6196 18.4668 78.6196 20.7812V21.4697C78.6196 23.7695 77.4016 25.1099 75.622 25.1099ZM75.2501 23.7695C76.2784 23.7695 76.9786 22.9419 76.9786 21.3818V20.8398C76.9786 19.3384 76.3222 18.4814 75.2209 18.4814C74.0904 18.4814 73.383 19.4043 73.383 20.8325V21.3818C73.383 22.8467 74.0977 23.7695 75.2501 23.7695Z",
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9749 22.2241H83.594C83.667 23.0884 84.4255 23.8281 85.8331 23.8281C87.124 23.8281 87.8898 23.2202 87.8898 22.2754C87.8898 21.5137 87.3793 21.1035 86.3145 20.8472L84.6807 20.437C83.3971 20.1367 82.2448 19.3677 82.2448 17.7417C82.2448 15.8301 83.9076 14.7827 85.8404 14.7827C87.7731 14.7827 89.385 15.8301 89.4214 17.6978H87.8315C87.7585 16.8481 87.1094 16.145 85.8185 16.145C84.6807 16.145 83.9076 16.687 83.9076 17.6172C83.9076 18.269 84.3598 18.7378 85.2861 18.9502L86.9125 19.353C88.4077 19.7192 89.5454 20.4297 89.5454 22.1289C89.5454 24.0918 87.9628 25.1978 85.7091 25.1978C82.9376 25.1978 82.0114 23.5718 81.9749 22.2241Z",
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5185 17.2583V15.376H93.1084V17.2583H94.6108V18.562H93.1084V22.6929C93.1084 23.5352 93.422 23.7695 94.2899 23.7695C94.4285 23.7695 94.5598 23.7695 94.6546 23.7549V25C94.5233 25.022 94.217 25.0513 93.8888 25.0513C92.0144 25.0513 91.4966 24.3774 91.4966 22.8247V18.562H90.4317V17.2583H91.5185Z",
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9834 17.1265C101.201 17.1265 102.404 18.6938 102.404 20.8032V21.4258C102.404 23.6084 101.208 25.1318 98.9834 25.1318C96.7589 25.1318 95.5482 23.6084 95.5482 21.4258V20.8032C95.5482 18.7012 96.7662 17.1265 98.9834 17.1265ZM98.9834 18.4302C97.78 18.4302 97.1819 19.4189 97.1819 20.8252V21.4185C97.1819 22.8027 97.7727 23.8208 98.9834 23.8208C100.194 23.8208 100.778 22.8101 100.778 21.4185V20.8252C100.778 19.4116 100.187 18.4302 98.9834 18.4302Z",
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.772 25V17.2583H105.391V18.2764H105.449C105.646 17.793 106.222 17.1484 107.294 17.1484C107.506 17.1484 107.688 17.1631 107.841 17.1924V18.6279C107.703 18.5913 107.418 18.5693 107.149 18.5693C105.85 18.5693 105.413 19.375 105.413 20.415V25H103.772Z",
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.769 25.1318C109.705 25.1318 108.392 23.7622 108.392 21.4697V20.686C108.392 18.5254 109.676 17.1265 111.703 17.1265C113.76 17.1265 115 18.5767 115 20.7593V21.499H109.989V21.6821C109.989 22.9858 110.69 23.8501 111.791 23.8501C112.615 23.8501 113.177 23.4399 113.374 22.7734H114.912C114.679 24.0259 113.673 25.1318 111.769 25.1318ZM109.989 20.3638H113.417V20.3491C113.417 19.2505 112.739 18.3862 111.711 18.3862C110.668 18.3862 109.989 19.2505 109.989 20.3491V20.3638Z",
    fill: "var(--fill-0, black)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_0_4_clip_path",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 40,
    rx: 20
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.732b708d0f3e0d2c5da8b9f111dd3873.svg";
export { ForwardRef as ReactComponent };